import React from "react";
import { SxProps } from "@mui/material";
import { Assignment as ReportIcon } from "@mui/icons-material";
import Section from "../../components/Section";
import InfoButton from "../../components/InfoButton";
import DialogExportReport from "./DialogExportReport";

const ControlSection = ({
  sx,
}: {
  sx?: SxProps,
}) => {
  const [dialogOpenExportReport, setDialogOpenExportReport] = React.useState(false);

  return (
    <Section sx={{ alignSelf: 'stretch', gap: 0.5, px: 2, ...sx }}>
      <InfoButton
        title='Export CRF Report'
        description='Export CRF data to a CSV file'
        icon={<ReportIcon fontSize='large' color='primary'/>}
        onClick={() => setDialogOpenExportReport(true)}
      />
      <DialogExportReport open={dialogOpenExportReport} onClose={() => setDialogOpenExportReport(false)}/>
    </Section>
  );
}

export default ControlSection;